import React, { useState } from 'react';
import { Route } from 'react-router-dom';
// import HeaderBar from '../../Shared/HeaderBar';
import { PrivateRoute } from '../../Pages/Auth/PrivateRoute';
import { Callback } from '../Auth/Callback';
import { Logout } from '../Auth/Logout';
import { LogoutCallback } from '../Auth/LogoutCallback';
import { SilentRenew } from '../Auth/SilentRenew';
import { makeStyles } from "@material-ui/core";
import { drawerWidth } from '../../../Config/constants';
import { AuthConsumer } from "../../../Helpers/auth.provider";
import { dataService } from '../../../Services/data/data.service';
import { systemParameters } from '../../../Config/constants';
import { popupDefinitions } from '../../../Config/popupDefinitions';
import { toast } from 'react-toastify';
import PickingOverview from '../../PickingOverview/pickingOverview';
import { connect } from 'react-redux';
import ScannerPage from '../../Scanner Page/scannerPage';
import PickingDetail from '../../PickingDetail/pickingDetail';

export const IndexPage = (props) => {

  const classes = useStyles();
  const [dataFetched, setDataFetched] = useState(false);

  const setInitialState = () => {
    let neededSystemParameters = [systemParameters.Silos, systemParameters.ExceedingOrderProgressColorFactors, systemParameters.NumberOfMachinesSimultanious, systemParameters.MaterialReasonForRequest, systemParameters.ReworkWorkstations];
    let neededPopups = [popupDefinitions.REPORT_PROBLEM_POPUP, popupDefinitions.OPERATOR_INSTRUCTIONS];

    Promise.all([
    ]).then((results) => {

      if (!dataFetched) {
        let popups = results[0];
        let settings = results[1];
        // props.actions.setPopups(popups);
        props.actions.setSystemParameters(settings);
        setDataFetched(true);
      }

    }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) });
  }

  return (
    <React.Fragment>
      <AuthConsumer>
        {({ isAuthenticated }) => {
          if (isAuthenticated()) {
            setInitialState()
            return <React.Fragment>
            </React.Fragment>
          }
        }}
      </AuthConsumer>
      <main className={classes.content}>
        <div className={classes.rootClass}>
          <Route exact={true} path="/signin-oidc" component={Callback} />
          <Route exact={true} path="/logout" component={Logout} />
          <Route exact={true} path="/scannerpage" component={ScannerPage} />
          <Route exact={true} path="/PickingDetail" component={PickingDetail} />
          <Route exact={true} path="/signout-oidc" component={LogoutCallback} />
          <Route exact={true} path="/silentrenew" component={SilentRenew} />
          <PrivateRoute exact path="/" component={(matchProps) => dataFetched ? <PickingOverview  {...matchProps}  {...props} actions={props.actions}  /> : <React.Fragment></React.Fragment>} />
        </div>
      </main>
      <div className={classes.powered}>Powered by Flagstone</div>
    </React.Fragment>
  )
}

const useStyles = makeStyles((theme) => ({

  backdrop: {
    zIndex: 100,
    color: '#fff',
    backgroundColor: '#EFEFEF'
  },

  rootClass: {
    display: 'flex',
    height: 'fit-content',
    minHeight: '100%',
    width: '100%',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    width: "calc(100% - 50px)",
    height: 'calc(100% - 60px)',

    [theme.breakpoints.down('sm')]: {
      height: 'calc(100% - 80px)',
      marginTop: '80px'

    },
    display: 'flex',

  },
  powered: {
    height: "20px",
    width: "150px",
    position: "absolute",
    bottom: "70",
    right: "40px",
    overflow: "hidden",
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    fontWeight: 'Medium',
    color: "#E8E8E8",
    zIndex: "-1"
  }

}));

function mapStateToProps(state) {
  return {
    general: state.general,
  }
}

export default connect(mapStateToProps)(IndexPage)